import React, { useMemo } from "react";
import { useFurnitureManagementState } from "@/state/furnitureManagementState";
import { useResourcesState } from "@/state/resourcesState";
import { Panel } from "@/dom/components/Panel/Panel";
import { Row } from "@/dom/components/Panel/Row";
import { Icon } from "@/dom/components/Icon/Icon";
import { Typography } from "@/dom/components/Typography/Typography";
import { formatPrice } from "@/utils/string";
import { Button } from "@/dom/components/Button/Button";
import css from "./OrderDetailsPreview.module.css";
import { useDemoState } from "@/state/demoState";

export const OrderDetailsPreview: React.FC = () => {
    const furnitureInstances = useFurnitureManagementState((state) => state.furnitureInstances);
    const allFurniture = useResourcesState((state) => state.furniture);
    const setIsOrderDetailsOpen = useDemoState((state) => state.setIsOrderDetailsOpen);

    const totalPrice = useMemo(() => {
        return Object.values(furnitureInstances).reduce((acc, instance) => {
            const furniture = allFurniture[instance.furnitureId];
            return acc + furniture.data.price;
        }, 0);
    }, [furnitureInstances, allFurniture]);

    return (
        <Panel className={css.main}>
            <Row>
                <Icon icon="sofa" size="32px" />
                <Row>
                    <Typography variant="subtitle">{formatPrice(totalPrice)}</Typography>
                    <Button
                        variant="secondary"
                        size="small"
                        onClick={() => setIsOrderDetailsOpen(true)}
                    >
                        Детали заказа
                    </Button>
                </Row>
            </Row>
        </Panel>
    );
};
